export const translations = {
	"incident": {
		"no": "sak"
	},
	"incidents": {
		"no": "saker"
	},
	'Number': {
		no: 'Nummer'
	},
	'Subject': {
		'no': 'Emne'
	},
	'Impact': {
		no: 'Innvirkning'
	},
	'Owner': {
		no: 'Eier'
	},
	'Reported by': {
		no: 'Rapportert av'
	},
	'Assigned to': {
		no: 'Tildelt til'
	}
};
